export default __webpack_public_path__ + "static/media/medina-vertical.a507ecd3.png";